export default "__VITE_ASSET__2Ranmsz0__"